/* LAYOUT */
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const CHANGE_LAYOUT_WIDTH = 'CHANGE_LAYOUT_WIDTH';
export const CHANGE_SIDEBAR_THEME = 'CHANGE_SIDEBAR_THEME';
export const CHANGE_SIDEBAR_TYPE = 'CHANGE_SIDEBAR_TYPE';

/* RIGHT SIDEBAR */
export const TOGGLE_RIGHT_SIDEBAR = 'TOGGLE_RIGHT_SIDEBAR';
export const SHOW_RIGHT_SIDEBAR = 'SHOW_RIGHT_SIDEBAR';
export const HIDE_RIGHT_SIDEBAR = 'HIDE_RIGHT_SIDEBAR';
export const CHANGE_COLUMN_SERVICE = 'CHANGE_COLUMN_SERVICE';
export const CHANGE_COLUMN_EXAM = 'CHANGE_COLUMN_EXAM';
export const CHANGE_COLUMN_BOOKING = 'CHANGE_COLUMN_BOOKING';
// export const CHANGE_COLUMN_WELCOME= 'CHANGE_COLUMN_WELCOME';
export const CHANGE_COLUMN_WAITING = 'CHANGE_COLUMN_WAITING';
export const CHANGE_COLUMN_RUNING = 'CHANGE_COLUMN_RUNING';
export const CHANGE_COLUMN_DONE = 'CHANGE_COLUMN_DONE';
export const CHANGE_COLUMN_CANCEL = 'CHANGE_COLUMN_CANCEL';
export const CHANGE_COLUMN_CANCELLING = 'CHANGE_COLUMN_CANCELLING';
export const CHANGE_COLUMN_ORDER = 'CHANGE_COLUMN_ORDER';

